export default __webpack_public_path__ + "static/media/S80.65cbb210.png";